enum TransformsAnchor {
  TopLeft,
  TopRight,
  BottomLeft,
  BottomRight,
  Center,
}

export default TransformsAnchor;
